<script>
    import { fade } from 'svelte/transition';
    import UserStore from '../stores/user';
    import fetchData from '../api.js';
    import {link, push} from 'svelte-spa-router'
    import { locale, _ } from 'svelte-i18n';
    import { onMount } from 'svelte';
    import { storeNames } from '../variables';
    import Header from '../components/Header.svelte'; 
    
    let logs = [];
    let selectedDate = '';
    let date_selected ='';
    let store_selected = '';

    let stores = [];
    
  
    onMount(async() => {
  
        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }
    
        //generateDates();     

        getLogs('date','')
        
        
        let stores_list = localStorage.getItem('stores');

        if (stores_list!='') {

            stores = JSON.parse(stores_list);  

        }
    
  
    });

    const getLogs = async (section,eventData)=> {

        if (section=='date') {

            if (!eventData) {
                // If date is empty, set it to today's date in Y-m-d format
                const today = new Date();
                const year = today.getFullYear();
                const month = String(today.getMonth() + 1).padStart(2, '0');
                const day = String(today.getDate()).padStart(2, '0');
                eventData = `${year}-${month}-${day}`;
            }else { 
                eventData = eventData.target.value;
                //date = date_selected;
            }

            selectedDate = eventData;
            date_selected = eventData;

        } else {

            if (eventData) {

                store_selected = eventData.target.value;

            }

        }

        

        const formData = {
            merchant_id : $UserStore.id,
            action : 'get_log',
            date : date_selected,
            store : store_selected,
            url : 'https://yehuda.dreamax.co.il/api/rest/get_log'
        }

        let data = await fetchData(formData);

        logs = data.data.map((log)=>{

            log.status = log.status;
            log.status_desc = '';

            if (log.status==6) {
                log.status_desc = 'הספקה חלקית';
            } else if (log.status==5) {
                log.status_desc = 'אושרה';
            } else if (log.status==3) {
                log.status_desc = 'סגורה';
            }

            return log

        })

    }  

    let dates = [];

    const generateDates = () => {
        const today = new Date();
        const thirtyDaysAgo = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000); // Subtract 30 days

        for (let date = thirtyDaysAgo; date <= today; date.setDate(date.getDate() + 1)) {
            const formattedDate = date.toISOString().slice(0, 10); // Y-m-d format
            dates.push(formattedDate);
        }

        console.log(dates)
    }

    generateDates();
  
  </script>
  
  <style>
    .note {
        display: flex;;
        padding: 20px 20px;
        border-bottom:1px solid #f1f1f1;
        font-size: 15px;;
        justify-content:space-between;
        align-items:flex-start;
        flex-direction: column;
        justify-content:flex-start;
    }
    .page-title {
        background: #000;
        color: #fff;
        padding: 10px
    }
    .page-date-select {
        display: flex;
    }
    .page-date-select select {
        padding:10px 20px;
        width:100%;
    }
    .empty {
        padding:10px;
        display: flex;
        justify-content: center;
    }
  </style>
  <Header />
  <div class="page" transition:fade={{ delay: 250, duration: 300 }}>
    <div class="page-title title">{$_('history.list')}</div>   
    <div class="page-date-select">
        <select on:change={e => getLogs('date', e)}>
            <option value="">{$_('history.select_date')}</option>
            {#each dates as date}
                <option value={date}>{date}</option>
            {/each}
        </select>
        <select on:change={e => getLogs('store', e)}>
            <option value="">{$_('history.select_shop')}</option>
            {#each Object.keys(stores) as store}
                <option value={store}>{storeNames[store]}</option>
            {/each}
        </select>
    </div>
    <div class="stores">
    {#if logs.length}
        {#each logs as log}
        <div class="note">
            <span><i class="fas fa-file"></i> מספר תעודה: {log.note}  <span class="note-status note-status{log.status}">{log.status_desc}</span></span>
            <span><i class="fas fa-building"></i> מעבר מחסנים: {log.store} <i class="fas fa-arrow-left"></i> {log.destination}</span>
            <span><i class="far fa-calendar"></i> תאריך: {log.date} </span>
            <span><i class="far fa-user"></i> משתמש: {log.name} </span>
        </div>
        {/each}
    {:else}
        <div class="empty">
            {$_('history.no_records')} {date_selected} 
            {#if store_selected}
            {$_('history.store_name')} {storeNames[store_selected]}
            {/if}
        </div>
    {/if}
    </div>
  </div>
  